import React, { useState, useRef, useEffect } from "react";
import Customform from "../../ui/custom-form";
import CustomInput from "../../ui/custom-input";
import CustomButton from "../../ui/custom-button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Verifyotp } from "../../api/api";
import { PulseLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { SetUserData } from "../../store/reducer/authUser";
import { useDispatch } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";

function VerifyOtp({ email, onBack }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    setError("");
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Only allow single digit
    setOtp(newOtp);

    // Move focus forward if input is valid
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const otpArray = pastedData.split("");
      setOtp(otpArray);

      otpArray.forEach((digit, idx) => {
        if (inputRefs.current[idx]) {
          inputRefs.current[idx].value = digit;
        }
      });

      inputRefs.current[5]?.focus();
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await Verifyotp({
        email,
        otp: otp.join(""),
      });
      //console.log("response", response);
      if (response.data?.status === true) {
        dispatch(SetUserData(response.data));
        navigate("/dashboard");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-75 text-center">
      <h3 className="title">Let's verify your email</h3>
      <p className="subTitle mt-3">
        Check <b>{email}</b> for the 6-digit verification code.
      </p>
      <Customform
        controlId="formOTP"
        className="otpBoxes mb-4"
        onSubmit={onSubmit}
      >
        <div className="otp-container my-5" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <CustomInput
              key={index}
              type="text"
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              maxLength={1}
              className="otp-input"
              ref={(el) => (inputRefs.current[index] = el)}
            />
          ))}
        </div>
        {error && <p className="text-danger">{error}</p>}
        <p className="resend mb-3">
          Did not get code? Click here for <button type="button">Resend</button>
        </p>
        <div className="d-flex flex-column align-items-center gap-4">
          <button
            type="submit"
            className="codepenButton submitBtn w-100"
            width="100%"
            size="large"
            disabled={loading}
          >
            {loading ? (
              <span className="loader">
                <PulseLoader color="#fff" />
              </span>
            ) : (
              <span>Next</span>
            )}
          </button>
          <button
            className="backButton pe-1"
            type="button"
            icon={<ArrowBackIosIcon />}
            iconPosition="left"
            variant="text"
            onClick={onBack}
          >
            <IoIosArrowBack size={26} />
          </button>
        </div>
      </Customform>
    </div>
  );
}

export default VerifyOtp;
